import React, { useState } from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DoneIcon from '@mui/icons-material/Done';
import styles from "./CourseEnroll.module.scss";

const handleCopyToClipboard = (link, setIsLinkCopied) => {
  navigator.clipboard.writeText(link);
  setIsLinkCopied(true);
  setTimeout(() => setIsLinkCopied(false), 2000);
};

const CourseEnroll = ({ uam_id }) => {
  const [isLinkCopied, setIsLinkCopied] = useState(false);
  const smartBatchingLink = `${process.env.REACT_APP_LEARN_URL}?uam_id=${uam_id}`;

  return (
    <div className={styles.dialog}>
      <div className={styles.header}>
        <h2 className={styles.title}>Priority Confirmation</h2>
      </div>

      <div className={styles.body}>
        <div className={styles.linkBox}>
          <p className={styles.link}>{smartBatchingLink}</p>
          <div
            onClick={() => handleCopyToClipboard(smartBatchingLink, setIsLinkCopied)}
            className={styles.copyBtn}
          >
            {isLinkCopied ? <DoneIcon /> : <ContentCopyIcon />}
          </div>
        </div>

        <ul className={styles.infoList}>
          <li>Ensure customer confirms batches to prioritize enrollment.</li>
          <li>Early confirmations get priority. Share the link with the customer for faster service.</li>
          <li> Use registered phone for authentication.</li>
          <li>Share only if the order has live classes.</li>
        </ul>
      </div>
    </div>
  );
};

export default CourseEnroll;
